import SFConfigureNewConnectedApp from './SFConfigureNewConnectedApp'
export default SFConfigureNewConnectedApp
